import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "./api";

const StoreCtx = createContext(null);

export function StoreProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("mci_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [settings, setSettings] = useState(null);

  useEffect(() => localStorage.setItem("mci_cart", JSON.stringify(items)), [items]);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const value = useMemo(
    () => ({
      items,
      settings,
      setSettings,
      add: (item) => setItems((p) => [...p, { ...item, key: crypto.randomUUID() }]),
      update: (key, patch) => setItems((p) => p.map((i) => (i.key === key ? { ...i, ...patch } : i))),
      remove: (key) => setItems((p) => p.filter((i) => i.key !== key)),
      clear: () => setItems([]),
    }),
    [items, settings]
  );
  return <StoreCtx.Provider value={value}>{children}</StoreCtx.Provider>;
}

export const useStore = () => useContext(StoreCtx);
